import { render, staticRenderFns } from "./FormControlUploadImage.vue?vue&type=template&id=bb1b1244&scoped=true&"
import script from "./FormControlUploadImage.vue?vue&type=script&lang=js&"
export * from "./FormControlUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./FormControlUploadImage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FormControlUploadImage.vue?vue&type=style&index=1&id=bb1b1244&scoped=true&lang=css&"
import style2 from "./FormControlUploadImage.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1b1244",
  null
  
)

export default component.exports